/**
 * allforwood 3D Studio - Universal Loader
 * Version: 1.8.1 (Custom Branding Color: #214156)
 */
(function() {
    const CONFIG = {
        namespace: 'allforwood_ar',
        buttonClass: 'allforwood-3d-button',
        modalClass: 'allforwood-modal',
        selectors: [
            '.product-form__buttons',
            '.product-single__add-to-cart',
            '[data-testid="product-form"]', 
            '.add-to-cart-container',
            '.product-form-submit',
            'form[action="/cart/add"]'
        ]
    };

    let currentState = {
        handle: null,
        metafields: {} 
    };

    /* PERF: JSON server-render không đổi sau khi load — parse 1 lần, không parse lại mỗi tick 500ms */
    let _cachedData = null;
    function getData() {
        if (_cachedData) return _cachedData;
        const script = document.getElementById('allforwood-product-data');
        if (!script) return { handle: null, variants: {} };
        try {
            const data = JSON.parse(script.textContent);
            _cachedData = {
                handle: data.handle || null,
                variants: data.variants || data
            };
            return _cachedData;
        } catch (e) {
            return { handle: null, variants: {} };
        }
    }

    function getCurrentVariantId() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('variant')) return params.get('variant');
        const input = document.querySelector('input[name="id"]');
        if (input) return input.value;
        const keys = Object.keys(currentState.metafields);
        return keys.length > 0 ? keys[0] : null;
    }

    function injectStyles() {
        if (document.getElementById('allforwood-styles')) return;
        const style = document.createElement('style');
        style.id = 'allforwood-styles';
        /* PERF: bỏ @import Google Fonts Inter — theme đè font-family bằng 'Sofia Pro !important'
           nên Inter không bao giờ được dùng, chỉ tốn 1 chuỗi request CSS + font bên ngoài */
        style.innerHTML = `
            .allforwood-3d-button {
                display: flex; align-items: center; justify-content: center; gap: 12px;
                width: 100%; padding: 14px 24px; margin: 15px 0;
                background: #ffffff; color: #214156; border: 2px solid #214156;
                border-radius: 12px; font-family: 'Inter', sans-serif;
                font-weight: 700; font-size: 15px; cursor: pointer;
                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                box-shadow: 0 1px 2px rgba(0,0,0,0.05);
            }
            .allforwood-3d-button:hover {
                background: #214156; color: #ffffff; transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(33, 65, 86, 0.2);
            }

            .allforwood-modal {
                position: fixed; inset: 0; background: rgba(33, 65, 86, 0.9);
                backdrop-filter: blur(8px); z-index: 2147483647;
                display: none; align-items: center; justify-content: center;
                opacity: 0; transition: opacity 0.3s ease; padding: 20px;
            }
            .allforwood-modal.is-open { display: flex; opacity: 1; }

            .allforwood-modal-content {
                width: 100%; max-width: 1000px; height: 85vh; background: #f9fafb;
                border-radius: 24px; position: relative; overflow: hidden;
                box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
                transform: scale(0.95); transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
            }
            .allforwood-modal.is-open .allforwood-modal-content { transform: scale(1); }

            .allforwood-close {
                position: absolute; top: 20px; right: 20px; z-index: 100;
                background: white; border: none; border-radius: 50%;
                width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;
                cursor: pointer; box-shadow: 0 4px 10px rgba(0,0,0,0.1); color: #214156;
            }

            .allforwood-ar-overlay {
                position: absolute; inset: 0; background: rgba(33, 65, 86, 0.85);
                display: flex; flex-direction: column; align-items: center; justify-content: center;
                z-index: 50; pointer-events: none; opacity: 0; transition: opacity 0.3s;
                text-align: center; padding: 20px;
            }
            .allforwood-ar-overlay.show { opacity: 1; pointer-events: auto; }
            
            .allforwood-ar-btn {
                background: #ffffff; color: #214156; padding: 18px 36px; border-radius: 50px;
                font-family: 'Inter', sans-serif; font-weight: 700; font-size: 18px;
                border: none; box-shadow: 0 10px 25px rgba(0,0,0,0.3);
                display: flex; align-items: center; gap: 12px; cursor: pointer;
                animation: pulse 2s infinite; margin-bottom: 16px;
            }
            @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }

            .allforwood-qr-container {
                position: absolute; bottom: 30px; left: 30px; z-index: 50;
                background: white; padding: 12px; border-radius: 16px;
                box-shadow: 0 10px 25px rgba(0,0,0,0.1); text-align: center;
                display: flex; flex-direction: column; items: center; gap: 6px;
                border: 1px solid rgba(0,0,0,0.05);
            }

            body.ar-mode-active { overflow: hidden !important; }
            body.ar-mode-active > *:not(.allforwood-modal) { display: none !important; }
            body.ar-mode-active .allforwood-modal { background: #214156; padding: 0; }
            body.ar-mode-active .allforwood-modal-content { width: 100%; height: 100%; border-radius: 0; max-width: none; }
            body.ar-mode-active .allforwood-close { top: 20px; right: 20px; background: rgba(255,255,255,0.2); color: white; backdrop-filter: blur(4px); }

            @media (max-width: 768px) {
                .allforwood-qr-container { display: none; }
                .allforwood-modal-content { height: 100%; border-radius: 0; }
                .allforwood-modal { padding: 0; }
            }

            model-viewer { width: 100%; height: 100%; background-color: #f3f4f6; }
        `;
        document.head.appendChild(style);
    }

    function openViewer(modelSrc, variantId, autoActivateAR = false) {
        let modal = document.querySelector(`.${CONFIG.modalClass}`);
        
        const domain = window.location.origin;
        const handle = currentState.handle;
        let qrTargetUrl = window.location.href; 

        if (handle) {
            const cleanVariantId = variantId ? variantId.toString().split('/').pop() : '';
            const pName = document.querySelector('h1')?.innerText || 'Product';
            
            const urlObj = new URL(`${domain}/pages/ar-viewer`);
            urlObj.searchParams.set('handle', handle);
            urlObj.searchParams.set('variant_id', cleanVariantId);
            urlObj.searchParams.set('glb', modelSrc); 
            urlObj.searchParams.set('name', pName);
            
            qrTargetUrl = urlObj.toString();
        }
        
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(qrTargetUrl)}`;

        if (!modal) {
            modal = document.createElement('div');
            modal.className = CONFIG.modalClass;
            modal.innerHTML = `
                <div class="allforwood-modal-content">
                    <button class="allforwood-close">
                        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                    
                    <model-viewer 
                        ar 
                        ar-modes="webxr scene-viewer quick-look" 
                        camera-controls 
                        auto-rotate 
                        shadow-intensity="1"
                        loading="eager"
                        ar-placement="floor"
                        ar-scale="auto"
                    >
                    </model-viewer>
                    
                    <div class="allforwood-ar-overlay">
                         <button class="allforwood-ar-btn">
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg>
                            Tap to Start AR
                         </button>
                         <p style="color:rgba(255,255,255,0.8); font-family:'Inter',sans-serif; font-size:14px; line-height:1.5;">
                            View this product in your own space.<br>Move your phone to detect the floor.
                         </p>
                    </div>

                    <div class="allforwood-qr-container">
                        <img src="${qrUrl}" width="140" height="140" style="mix-blend-mode: multiply;" />
                        <span style="font-family:'Inter',sans-serif; font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; margin-top:8px;">Scan with Phone</span>
                    </div>
                </div>
            `;
            document.body.appendChild(modal);
            modal.querySelector('.allforwood-close').onclick = () => {
                modal.classList.remove('is-open');
                document.body.classList.remove('ar-mode-active');
            };

            if (!window.customElements.get('model-viewer')) {
                const script = document.createElement('script');
                script.type = 'module';
                script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js';
                document.head.appendChild(script);
            }
        }

        const mv = modal.querySelector('model-viewer');
        mv.src = modelSrc;
        mv.removeAttribute('ios-src'); 

        const qrImg = modal.querySelector('.allforwood-qr-container img');
        if (qrImg) qrImg.src = qrUrl;

        const overlay = modal.querySelector('.allforwood-ar-overlay');
        overlay.classList.remove('show');
        
        modal.querySelector('.allforwood-ar-btn').onclick = () => {
             mv.activateAR();
             overlay.classList.remove('show');
        };

        modal.classList.add('is-open');

        if (autoActivateAR) {
            document.body.classList.add('ar-mode-active');
            overlay.classList.add('show');
        }
    }

    function init() {
        injectStyles();
        
        let attempts = 0;
        const checkInterval = setInterval(() => {
            attempts++;
            const data = getData();
            currentState.handle = data.handle;
            currentState.metafields = data.variants;

            const hasData = currentState.metafields && Object.keys(currentState.metafields).length > 0;
            const variantId = getCurrentVariantId();
            
            const params = new URLSearchParams(window.location.search);
            const isAuto = params.get('allforwood_ar') === '1';

            if (isAuto && hasData) {
                const vData = currentState.metafields[variantId];
                if (vData && vData.model_src) {
                    clearInterval(checkInterval);
                    openViewer(vData.model_src, variantId, true); 
                    return;
                }
            }

            if (hasData) {
                const vData = currentState.metafields[variantId];
                let btn = document.querySelector(`.${CONFIG.buttonClass}`);
                
                if (vData && vData.model_src) {
                    if (!btn) {
                        btn = document.createElement('button');
                        btn.type = 'button';
                        btn.className = CONFIG.buttonClass;
                        btn.innerHTML = `
                            <svg viewBox="0 0 24 24" width="22" height="22" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path>
                            </svg>
                            <span>View in 3D & AR</span>
                        `;
                        for (const selector of CONFIG.selectors) {
                            const el = document.querySelector(selector);
                            if (el) { el.parentNode.insertBefore(btn, el); break; }
                        }
                    }
                    if (btn) {
                        btn.style.display = 'flex';
                        btn.onclick = () => openViewer(vData.model_src, variantId);
                    }
                } else if (btn) {
                    btn.style.display = 'none';
                }
            }
            
            if (!isAuto && attempts > 40) clearInterval(checkInterval);
        }, 500);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();